/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/**
 * MultisigType defines the governance layer a multisig belongs to.
 * Different types have different permissions and requirements.
 */
export enum MultisigType {
  Protocol,
  Dao,
  Dispute,
  AgentConsortium,
  AgentTreasury,
  Custom,
}

export type MultisigTypeArgs = MultisigType;

export function getMultisigTypeEncoder(): FixedSizeEncoder<MultisigTypeArgs> {
  return getEnumEncoder(MultisigType);
}

export function getMultisigTypeDecoder(): FixedSizeDecoder<MultisigType> {
  return getEnumDecoder(MultisigType);
}

export function getMultisigTypeCodec(): FixedSizeCodec<
  MultisigTypeArgs,
  MultisigType
> {
  return combineCodec(getMultisigTypeEncoder(), getMultisigTypeDecoder());
}
